import Icon from '../../components/Icon.vue'

Icon.register({"regular/window-maximize":{"width":512,"height":512,"paths":[{"d":"M464 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H464C490.5 480 512 458.5 512 432V80C512 53.5 490.5 32 464 32zM464 426C464 429.3 461.3 432 458 432H54C50.7 432 48 429.3 48 426V192H464V426z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/window-maximize.js
// module id = jIri
// module chunks = 0